/**
 * The page of an RO with an Outstanding List record (`state` is set), or null for one
 * without.
 *
 * An RO that never reached the list (Ready, Closed, Closed and submitted straight from
 * intake) has no page of its own. It opens Manage Repair Order instead, which shows
 * everything the retired RO Claims view did (2026-09-28).
 */
export const roHref = (ro, dealerId) =>
  ro.state ? `/dealer/${dealerId}/repair-order/${ro.id}` : null
